import React, { useEffect, useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon, XIcon, TrashIcon } from 'lucide-react';
export function SollecitiAutomationsTab() {
  const [tipologia, setTipologia] = useState('standard');
  const [config, setConfig] = useState({
    amichevole: {
      numeroSolleciti: 2,
      giorniAttesa: 7,
      avanzamentoAutomatico: true
    },
    formale: {
      numeroSolleciti: 2,
      giorniAttesa: 10,
      avanzamentoAutomatico: true
    },
    duro: {
      numeroSolleciti: 1,
      giorniAttesa: 7,
      avanzamentoAutomatico: true
    },
    pec: {
      giorniAttesa: 15,
      avanzamentoAutomatico: false
    }
  });
  const [customTypes, setCustomTypes] = useState([]);
  // Gestisce il cambio di tutti i flag in base alla tipologia selezionata
  useEffect(() => {
    if (tipologia === 'manuale') {
      // Disattiva tutti i flag
      const updatedConfig = {
        ...config
      };
      Object.keys(updatedConfig).forEach(key => {
        if (updatedConfig[key].hasOwnProperty('avanzamentoAutomatico')) {
          updatedConfig[key].avanzamentoAutomatico = false;
        }
      });
      setConfig(updatedConfig);
    } else if (tipologia === 'automatico') {
      // Attiva tutti i flag
      const updatedConfig = {
        ...config
      };
      Object.keys(updatedConfig).forEach(key => {
        if (updatedConfig[key].hasOwnProperty('avanzamentoAutomatico')) {
          updatedConfig[key].avanzamentoAutomatico = true;
        }
      });
      setConfig(updatedConfig);
    }
  }, [tipologia]);
  const handleConfigChange = (fase, campo, valore) => {
    setConfig({
      ...config,
      [fase]: {
        ...config[fase],
        [campo]: valore
      }
    });
  };
  const handleTipologiaChange = e => {
    setTipologia(e.target.value);
  };
  const handleSaveConfig = () => {
    // Qui andrebbe la logica per salvare la configurazione
    alert('Configurazione salvata con successo');
  };
  // Descrizioni delle tipologie
  const tipologiaDescriptions = {
    manuale: "In modalità Manuale il sistema invia solo ciò che viene esplicitamente avviato dall'operatore e, allo scadere dei tempi, genera una notifica senza procedere oltre.",
    standard: "In modalità Standard l'invio dei solleciti all'interno della singola fase segue i parametri impostati, mentre il passaggio alla fase successiva avviene solo se l'operatore lo conferma oppure se è attivato il relativo flag di avanzamento.",
    automatico: "In modalità Automatico sia l'invio sia l'avanzamento tra le fasi sono governati dai parametri temporali e dai flag, senza necessità di intervento umano."
  };
  // Renderizza un blocco di configurazione per un tipo di sollecito
  const renderSollecitoConfig = (key, name, bgColor) => {
    const configData = config[key];
    return <div className={`${bgColor} p-4 rounded-lg`} data-id="element-1470">
        <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1471">{name}</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1472">
          {key !== 'pec' && <div data-id="element-1473">
              <label htmlFor={`${key}-num`} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1474">
                Numero di solleciti da inviare
              </label>
              <input type="number" id={`${key}-num`} min="1" max="5" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={configData.numeroSolleciti} onChange={e => handleConfigChange(key, 'numeroSolleciti', parseInt(e.target.value))} data-id="element-1475" />
            </div>}
          <div data-id="element-1476">
            <label htmlFor={`${key}-giorni`} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1477">
              Giorni di attesa dopo l'ultimo invio
            </label>
            <input type="number" id={`${key}-giorni`} min="1" max={key === 'pec' ? 60 : 30} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" value={configData.giorniAttesa} onChange={e => handleConfigChange(key, 'giorniAttesa', parseInt(e.target.value))} data-id="element-1478" />
          </div>
        </div>
        {configData.hasOwnProperty('avanzamentoAutomatico') && <div className="mt-4" data-id="element-1479">
            <div className="flex items-center" data-id="element-1480">
              <input id={`${key}-auto`} name={`${key}-auto`} type="checkbox" className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" checked={configData.avanzamentoAutomatico} onChange={e => handleConfigChange(key, 'avanzamentoAutomatico', e.target.checked)} data-id="element-1481" />
              <label htmlFor={`${key}-auto`} className="ml-2 block text-sm text-gray-700" data-id="element-1482">
                Abilita avanzamento automatico alla fase successiva
              </label>
            </div>
            <p className="mt-1 text-xs text-gray-500" data-id="element-1483">
              Se disattivato, il sistema notificherà l'operatore e attenderà la
              conferma manuale
            </p>
          </div>}
      </div>;
  };
  return <Card data-id="element-1484">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1485">
        Configurazione Automazioni Solleciti
      </h3>
      <div className="mb-6" data-id="element-1486">
        <label htmlFor="tipologia" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1487">
          Tipologia di solleciti
        </label>
        <div className="flex items-center space-x-4" data-id="element-1488">
          <select id="tipologia" name="tipologia" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={tipologia} onChange={handleTipologiaChange} data-id="element-1489">
            <option value="manuale" data-id="element-1490">Manuale</option>
            <option value="standard" data-id="element-1491">Standard</option>
            <option value="automatico" data-id="element-1492">Automatico</option>
          </select>
        </div>
        <p className="mt-2 text-sm text-gray-500" data-id="element-1493">
          {tipologiaDescriptions[tipologia]}
        </p>
      </div>
      <div className="space-y-8" data-id="element-1494">
        {/* Solleciti predefiniti */}
        {renderSollecitoConfig('amichevole', 'Sollecito Amichevole', 'bg-blue-50')}
        {renderSollecitoConfig('formale', 'Sollecito Formale', 'bg-yellow-50')}
        {renderSollecitoConfig('duro', 'Sollecito Duro', 'bg-orange-50')}
        {renderSollecitoConfig('pec', 'PEC Ufficiale', 'bg-purple-50')}
        {/* Solleciti personalizzati */}
        {customTypes.map((type, index) => renderSollecitoConfig(type.key, type.name, 'bg-gray-50'))}
      </div>
      <div className="mt-8 flex justify-end" data-id="element-1495">
        <Button type="button" onClick={handleSaveConfig} icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1497" />} data-id="element-1496">
          Salva Configurazione
        </Button>
      </div>
    </Card>;
}